import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { Sun, Moon } from "lucide-react";
import { axiosClient } from "@/lib/axiosClient";

const ForgotPasswordPage: React.FC = () => {
    const [email, setEmail] = useState<string>("");
    const [darkMode, setDarkMode] = useState(false);
    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);

        try {
            await axiosClient.post("/forgot-password", { email });
            toast.success("Link reset password telah dikirim ke email Anda.");
            setTimeout(() => navigate("/login"), 3000);
        } catch (error) {
            console.error(error);
            toast.error("Gagal mengirim link reset password.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className={`min-h-screen flex items-center justify-center relative transition-colors duration-500 ${darkMode
                ? "bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-slate-100"
                : "bg-gradient-to-br from-[#eef6ff] via-[#e6efff] to-[#dce8ff] text-slate-800"
                }`}
        >
            {/* Toggle mode */}
            <button
                onClick={() => setDarkMode(!darkMode)}
                className="absolute top-5 right-5 p-2 rounded-full hover:bg-slate-200/30 dark:hover:bg-slate-700/50 transition"
                aria-label="Toggle mode"
            >
                {darkMode ? (
                    <Sun className="h-5 w-5 text-yellow-400" />
                ) : (
                    <Moon className="h-5 w-5 text-blue-700" />
                )}
            </button>

            <Toaster />
            <form
                onSubmit={handleSubmit}
                className="bg-white p-8 rounded-xl shadow-md w-full max-w-md"
            >
                <h2 className="text-2xl font-semibold text-center mb-6">
                    Lupa Kata Sandi
                </h2>

                <div className="mb-4">
                    <label className="block text-sm text-gray-700 mb-2">
                        Alamat Email
                    </label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    />
                </div>

                <button
                    type="submit"
                    disabled={loading}
                    className="w-full bg-indigo-600 text-white py-2 rounded-lg font-medium hover:bg-indigo-700 transition"
                >
                    {loading ? "Mengirim..." : "Kirim Link Reset"}
                </button>
            </form>
        </div>
    );
};

export default ForgotPasswordPage;
